import {
  DashboardOutlined,
  CreditCardOutlined,
  LogoutOutlined,
  FileSearchOutlined,
  SettingOutlined,
  DollarCircleOutlined,
  ScheduleOutlined,
} from "@ant-design/icons";
import { Button, Layout, Menu, Tooltip, message, ConfigProvider } from "antd";
import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import routes from "../constants/routes.json";
import logoDormakaba from "../images/logo-dormakaba.png";
import thTH from "antd/lib/locale/th_TH";
import enUS from "antd/lib/locale/en_US";
import { getToken } from "./../redux/helper/localstorageHelper";
import "../app.global.css";
import locale from "../constants/locale.json";

const { SubMenu } = Menu;
const { Header, Sider, Content } = Layout;

const App = (props) => {
  const history = useHistory();
  const { children, lang } = props;
  const currentLang = (lang && lang.currentLang) || "en-US";
  const logout = () => {
    localStorage.removeItem("token");
    history.push("/");
  };

  const [features, setFeatures] = useState([]);

  const getMenuAllowed = (feature, menuName, menuKey, menuLink) => {
    if (
      feature &&
      (feature.is_read ||
        feature.is_create ||
        feature.is_update ||
        feature.is_delete)
    ) {
      return (
        <Menu.Item key={menuKey}>
          {menuName}
          <Link to={menuLink} />
        </Menu.Item>
      );
    }

    return <></>;
  };

  useEffect(() => {
    const tokenJSON = getToken("token");
    if (tokenJSON) {
      const token = JSON.parse(tokenJSON).accessToken;
      fetch(`/api/v1/user/features`, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          token: token,
        },
      })
        .then((res) => {
          if (!res.ok) {
            return res
              .json()
              .catch(() => {
                // Couldn't parse the JSON
                throw new Error(res.statusText);
              })
              .then(({ error }) => {
                // Got valid JSON with error response, use it
                throw new Error(error || res.statusText);
              });
          }
          return res.json();
        })
        .then((res) => {
          const { features } = res;
          setFeatures(features);
        })
        .catch((err) => {
          message.error(
            err instanceof Error ? err.message : "Server cannot be reached"
          );
        });
    }
  }, []);

  // dormakaba-theme
  // hafele-theme
  // default-theme
  const [theme] = useState("dormakaba-theme");
  let logo = logoDormakaba;

  const newPathArr = [props.location.pathname.split("/")[1]];

  return (
    <Layout style={{ height: "100vh" }} className={theme}>
      <Sider trigger={null} id="sidebar">
        <div className="logo-container">
          <div className="logo-content">
            <img alt="logo" src={logo} />
          </div>
        </div>
        <div
          style={{
            flex: "1 1 0%",
            overflow: "hidden auto",
          }}
        >
          <Menu
            theme="dark"
            mode="inline"
            selectedKeys={newPathArr}
            className="cb-menu"
          >
            {features["DASHBOARD_OVERVIEW"] ? (
              <SubMenu
                key="dashboard"
                icon={<DashboardOutlined />}
                title={"Dashboard"}
              >
                {getMenuAllowed(
                  features["DASHBOARD_OVERVIEW"],
                  "Overview",
                  "overview",
                  routes.DashboardOverview
                )}
              </SubMenu>
            ) : (
              <></>
            )}
            {features["RATE_TICKET"] || features["RATE_TYPE"] ? (
              <SubMenu
                key="rate"
                icon={<DollarCircleOutlined />}
                title={"Rate"}
              >
                {getMenuAllowed(
                  features["RATE_CAR"],
                  "Car",
                  "ratecar",
                  routes.RateCar
                )}
                {getMenuAllowed(
                  features["RATE_MOTO"],
                  "Moto",
                  "ratemoto",
                  routes.RateMoto
                )}
                {getMenuAllowed(
                  features["RATE_TYPE"],
                  locale.app.feature["ratetype"].title[currentLang],
                  "ratetype",
                  routes.RateType
                )}
              </SubMenu>
            ) : (
              <></>
            )}
            {features["SHIFT_TYPE"] ? (
              <SubMenu key="shift" icon={<ScheduleOutlined />} title={"Shift"}>
                {getMenuAllowed(
                  features["SHIFT_TYPE"],
                  "Type",
                  "shifttype",
                  routes.ShiftType
                )}
              </SubMenu>
            ) : (
              <></>
            )}
            {features["CARD_REGISTRATION"] ? (
              <SubMenu
                key="card"
                icon={<CreditCardOutlined />}
                title={locale.app.feature["card"].title[currentLang]}
              >
                {getMenuAllowed(
                  features["CARD_REGISTRATION"],
                  locale.app.feature["registration"].title[currentLang],
                  "cardregistration",
                  routes.CardRegistration
                )}
              </SubMenu>
            ) : (
              <></>
            )}

            {features["REPORT_TICKET"] || features["REPORT_CARD"] ? (
              <SubMenu
                key="report"
                icon={<FileSearchOutlined />}
                title={locale.app.feature["report"].title[currentLang]}
              >
                {getMenuAllowed(
                  features["REPORT_TICKET"],
                  "Ticket Log",
                  "reportticket",
                  routes.ReportTicketLog
                )}
                {getMenuAllowed(
                  features["REPORT_CARD"],
                  "Card Access Log",
                  "reportcard",
                  routes.ReportCardLog
                )}
                {getMenuAllowed(
                  features["REPORT_SHIFT"],
                  "Shift Log",
                  "reportshift",
                  routes.ReportShiftLog
                )}
              </SubMenu>
            ) : (
              <></>
            )}
            {features["SYSTEM_USER"] || features["SYSTEM_ROLE"] ? (
              <SubMenu key="system" icon={<SettingOutlined />} title={"System"}>
                {getMenuAllowed(
                  features["SYSTEM_USER"],
                  "User",
                  "user",
                  routes.User
                )}
                {getMenuAllowed(
                  features["SYSTEM_ROLE"],
                  "Role",
                  "role",
                  routes.Role
                )}
              </SubMenu>
            ) : (
              <></>
            )}
          </Menu>
        </div>
      </Sider>
      <Layout className="site-layout">
        <Header className="site-layout-header" style={{ padding: 0 }}>
          <div className="site-layout-header-right">
            {/* <HeaderSelectLang /> */}
            <Tooltip
              placement="bottom"
              title={locale.app.menu.logout[currentLang]}
            >
              <span className="site-layout-header-right-item ">
                <Button
                  type="link"
                  onClick={logout}
                  style={{ color: "rgba(0, 0, 0, 0.65)" }}
                  icon={<LogoutOutlined />}
                />
              </span>
            </Tooltip>
          </div>
        </Header>
        <Content
          className="site-layout-background"
          style={{
            margin: "20px",
            display: "flex",
            minHeight: 280,
          }}
        >
          <ConfigProvider
            locale={lang && lang.currentLang === "th-TH" ? thTH : enUS}
          >
            {children}
          </ConfigProvider>
        </Content>
      </Layout>
    </Layout>
  );
};

function mapStateToProps({ lang }) {
  return {
    lang,
  };
}

export default connect(mapStateToProps, null)(App);
